var React = require('react');

function Rectangular (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"sec-topPoly","points":"0 0, 101 0, 101 101, 0 101"}));
}

Rectangular.defaultProps = {"viewBox":"0 0 100 100","preserveAspectRatio":"none","style":{"marginTop":"-1px"}};

module.exports = Rectangular;

Rectangular.default = Rectangular;
